angular.module('leftPaneModule')
  .controller('LeftPaneTeacherController', [
    '$scope', '$rootScope', '$state', 'teacherApi', 'authentication', 'timeframe', 'edxReportItemService',
    function ($scope, $rootScope, $state, $teacherApi, dblAuthentication, timeframe, edxReportItemService) {

      var updateTeacherData = function () {
          // Get Teacher data here - name - description, highlights, etc.
          var params = $state.params;
          $teacherApi.getTeacherData(params.teacherId, function (data) {
              $scope.teacherData = data;
              timeframe.getYearListSubject().onNext(data.years);
              // deprecated: use timeframe.getYearListSubject instead of broadcast
              $rootScope.$broadcast('updateYears', data.years);
          });
      };

      var initializeData = function (item) {
          $scope.item = item;
          updateTeacherData();

          $scope.viewType = dblAuthentication.growthAsFraction() ? 'fractionMode' : 'percentMode';
      };

      var itemSubscription = edxReportItemService.getCurrentItemObservable().subscribe(initializeData);

      var initializeItemSettings = function (e, settingsItem) {
          $scope.teacherSettings = settingsItem;
          $scope.teacherProductSettings = settingsItem;
      };
      $scope.$on('settingsItemReady', initializeItemSettings);     
      $scope.$on('$destroy', function () {
          itemSubscription.dispose();
      });
  }]);
